<div class="col">
  @if (showSourceOrganizationControlSwitch && hasOrganizationOptions$ | async) {
    <p-floatlabel variant="in" [dt]="props.dt?.components?.floatlabel">
      <p-select
        [dt]="props.dt?.components?.select"
        [formControl]="sourceOrganizationControlSwitch"
        [options]="organizationOptions$ | async"
      />

      <label>
        {{ props.sourceLabel }}
      </label>
    </p-floatlabel>
  }

  @if (messages.length) {
    <p-message severity="warn" variant="simple" size="small" [dt]="props.dt?.components?.message">
      @for (message of messages; track message) {
        {{ message }}
        @if (!$last) {
          <br />
        }
      }
    </p-message>
  }
</div>
